import type { UserBadge } from "@sorcery/db";
import { UserBadgeEnum } from "@sorcery/db";
import { beautify } from "@sorcery/utils/universal/string";

import { cn } from "../../lib/utils";

export const Achievements = ({
  badges,
  slim,
}: {
  badges: UserBadge[];
  slim?: boolean;
}) => {
  return (
    <div className={cn(slim && "max-h-32 overflow-auto")}>
      {Object.values(UserBadgeEnum).map((b) => {
        const badge = badges.find((badge) => badge.name === b);
        if (!badge) return null;
        return (
          <div key={badge.id} className="mb-1">
            <span>{beautify(b)}</span>
          </div>
        );
      })}
    </div>
  );
};
